import { render, staticRenderFns } from "./StudentResearch.vue?vue&type=template&id=07e91986&scoped=true"
import script from "./StudentResearch.vue?vue&type=script&lang=js"
export * from "./StudentResearch.vue?vue&type=script&lang=js"
import style0 from "./StudentResearch.vue?vue&type=style&index=0&id=07e91986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e91986",
  null
  
)

export default component.exports